import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles';
import { flowRight as compose } from 'lodash';
import { injectIntl } from 'react-intl';
import { gql } from '@apollo/client';
import {
  Row,
  Col,
  Grid
} from 'react-bootstrap';
import cx from 'classnames';

import { withQuery } from '../../hoc/withGraphql';
import { dynamicFooterValue } from '../../helpers/GetDynamicItemName/dynamicHomeValue';

// Image icons
import iconOne from '/public/SiteIcons/supportIconOne.svg';
import iconTwo from '/public/SiteIcons/supportIconTwo.svg';
import iconThree from '/public/SiteIcons/supportIconThree.svg';

import cs from '../commonStyle.css';
import s from './Feedback.css';

const Feedback = ({ data: { loading, getFooterSetting }, intl }) => {
  const footerData = React.useMemo(() => {
    return dynamicFooterValue(getFooterSetting, intl?.locale);
  }, [getFooterSetting, intl?.locale]);

  const { title1, content1, title2, content2, title3, content3 } = footerData;

  if (!loading) {
    return (
      <div className={s.root}>
        <div className={s.container}>
          <div className={s.feedbackContainer}>
            <Row className={s.feedbackRow}>

              {
                getFooterSetting && <Col
                  xs={12} sm={4} md={4} lg={4}
                  className={cx(s.feedbackBox, s.borderRight, 'borderRightFeedRTL')}>
                  <img src={iconOne} />
                  <div>
                    <label className={cx(cs.commonSubTitleText, cs.paddingTop4, cs.fontWeightBold)}>{title1}</label>
                    <label className={cx(cs.paddingTop2, cs.commonContentText, cs.fontWeightNormal, s.textColor)}>{content1}</label>
                  </div>
                </Col>
              }
              {
                getFooterSetting && <Col
                  xs={12} sm={4} md={4} lg={4}
                  className={cx(s.feedbackBox, s.borderRight, 'borderRightFeedRTL')}
                >
                  <img src={iconTwo} />
                  <div className={cx(s.feedbackContent, 'textAlignRightRTL')}>
                    <label className={cx(cs.commonSubTitleText, cs.paddingTop4, cs.fontWeightBold)}>{title2}</label>
                    <label className={cx(cs.paddingTop2, cs.commonContentText, cs.fontWeightNormal)}>
                      {content2}
                    </label>
                  </div>
                </Col>
              }
              {
                getFooterSetting && <Col
                  xs={12} sm={4} md={4} lg={4}
                  className={cx(s.feedbackBox)}
                >
                  <img src={iconThree} />

                  <div className={cx(s.feedbackContent, 'textAlignRightRTL')}>
                    <label className={cx(cs.commonSubTitleText, cs.paddingTop4, cs.fontWeightBold)}> {title3}</label>
                    <label className={cx(cs.paddingTop2, cs.commonContentText, cs.fontWeightNormal)}>{content3}</label>
                  </div>
                </Col>
              }
            </Row>
          </div>
        </div>
      </div>
    );
  } else {
    return <div ></div>
  }
}
Feedback.propTypes = {
  data: PropTypes.shape({
    loading: PropTypes.bool,
    getFooterSetting: PropTypes.shape({
      title1: PropTypes.string.isRequired,
      content1: PropTypes.string.isRequired,
      title2: PropTypes.string.isRequired,
      content2: PropTypes.string.isRequired,
      title3: PropTypes.string.isRequired,
      content3: PropTypes.string.isRequired,
      dynamicFooterBlock: PropTypes.arrayOf(PropTypes.shape({
        language: PropTypes.string,
        title1: PropTypes.string,
        content1: PropTypes.string,
        title2: PropTypes.string,
        content2: PropTypes.string,
        title3: PropTypes.string,
        content3: PropTypes.string,
      }))
    })
  }),
};

export default compose(
  injectIntl,
  withStyles(cs, s),
  withQuery(gql`
   query getFooterSetting {
    getFooterSetting {
        id
        title1
        content1
        title2
        content2
        title3
        content3
        dynamicFooterBlock {
          language
          title1
          content1
          title2
          content2
          title3
          content3
        }
      }
    }
`, { options: { ssr: false } })
)(Feedback);